export const appLoadingSlice = 'appLoading';
